import React from "react";
import classnames from "classnames";
import { isEmpty, map, round } from "lodash";
import { AiccGrammarFeedback, AiccPronunciationFeedback } from "types/model/aiccCustomer";
import AudioPlayButton from "./AudioPlayButton";
import styles from "./Transcript.module.scss";

interface Props {
  grammarFeedback: AiccGrammarFeedback[];
  pronunciationFeedback: AiccPronunciationFeedback[];
}

const LOW_SCORE_LIMIT = 70;
const MEDIUM_SCORE_LIMIT = 85;

const getScoreStyle = (score: number) => {
  if (score < LOW_SCORE_LIMIT) {
    return styles.lowScore;
  }
  return score < MEDIUM_SCORE_LIMIT ? styles.mediumScore : styles.highScore;
};

function MessageFeedback({ grammarFeedback, pronunciationFeedback }: Props) {
  return (
    <>
      {!isEmpty(grammarFeedback) && (
        <div className={styles.feedbackSection}>
          <div className={styles.feedbackTitle}>Grammar feedback:</div>
          <ul className={styles.grammarList}>
            {map(grammarFeedback, ({ originalText, correctedText, explanation }, index) => (
              <li key={index}>
                <span className={styles.correctionChip}>
                  {originalText} {"-->"} {correctedText}
                </span>
                {explanation && <span className={styles.explanation}>{explanation}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}

      {!isEmpty(pronunciationFeedback) && (
        <div className={styles.feedbackSection}>
          <div className={styles.feedbackTitle}>Pronunciation:</div>
          <div className={styles.pronunciationList}>
            {map(pronunciationFeedback, ({ word, accuracyScore, pronunciationAudio }, index) => (
              <span key={index} className={classnames(styles.scoreChip, getScoreStyle(accuracyScore))}>
                {word} {round(accuracyScore)}
                {pronunciationAudio && <AudioPlayButton url={pronunciationAudio} className={styles.scorePlay} />}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default MessageFeedback;
